
<ng-progress color="#F7D50A"
id="progress-bar"></ng-progress>

<div *ngIf="!isLoggedIn && isLoggedIn != null">
    <app-open-page-layout></app-open-page-layout>
</div>

<div *ngIf="isLoggedIn && isLoggedIn != null">
    <app-closed-page-layout></app-closed-page-layout>
</div>

<app-notification aria-live="alert" aria-atomic="true"></app-notification>
